import { createFileRoute, Navigate } from "@tanstack/react-router";
import type { JSX } from "react";

const LegacyTeamsTabsConfigRedirect = (): JSX.Element => <Navigate to="/teams/tabs-config" />;

export const Route = createFileRoute("/teams-tabs-config")({
	component: LegacyTeamsTabsConfigRedirect,
});
